import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { ListItem, ListItemText, Stack, Typography } from '@mui/material'
import {
  getSuspensionReasonLabel,
  OTHER_SUSPENSION_REASON,
  UNSUSPEND_SUSPENSION_REASON,
} from 'components/customer-details/content/suspensions/settings'
import { convertDateTimeToPreferedTimezone } from 'data/dateTime/convertDateTimeToPreferedTimezone'

const SuspensionHistoryItem = ({ suspensionType, description, createdBy, createdAt, rescheduleWorkOrders }) => {
  const isSuspension = suspensionType !== UNSUSPEND_SUSPENSION_REASON
  const isOtherReason = suspensionType === OTHER_SUSPENSION_REASON
  const reasonLabel = useMemo(() => getSuspensionReasonLabel(suspensionType), [suspensionType])
  const { onlyDate, onlyTime } = convertDateTimeToPreferedTimezone({ dateTime: createdAt })

  const hasDescription = Boolean(description)
  // Unsuspends predating the stored choice carry null, and there is nothing truthful to show for those.
  const hasWorkOrderOutcome = !isSuspension && typeof rescheduleWorkOrders === 'boolean'

  return (
    <ListItem divider disablePadding>
      <ListItemText
        disableTypography
        primary={
          <Stack>
            <Typography gutterBottom variant="h6" fontWeight={500} color={isSuspension ? 'error' : 'success.main'}>
              {isSuspension ? 'Suspended' : 'Unsuspended'}
            </Typography>
            {isSuspension && (
              <Typography fontWeight={400} variant="h6">
                {isOtherReason && hasDescription ? `Other: ${description}` : reasonLabel}
              </Typography>
            )}
            {isSuspension && !isOtherReason && hasDescription && (
              <Typography color="textSecondary" variant="body2">
                {description}
              </Typography>
            )}
            {hasWorkOrderOutcome && (
              <Typography fontWeight={400} variant="h6">
                {rescheduleWorkOrders ? 'Work orders unheld' : 'Work orders kept on hold'}
              </Typography>
            )}
          </Stack>
        }
        secondary={<Typography color="textSecondary">{`Updated by ${createdBy} | ${onlyDate} @${onlyTime}`}</Typography>}
      />
    </ListItem>
  )
}

SuspensionHistoryItem.propTypes = {
  suspensionType: PropTypes.string,
  createdAt: PropTypes.string,
  description: PropTypes.string,
  createdBy: PropTypes.string,
  rescheduleWorkOrders: PropTypes.bool,
}

export default SuspensionHistoryItem
